import type {
  UserVideoKYCStartInput,
  UserQuickKYCInput,
  UserAddVideoDocumentInput,
  UserQuickKYCVerifyInput,
  RequestParams,
} from '../api'
import { ContentType, api } from '../api'

const quick = async (data: UserQuickKYCInput) => {
  return await api.v1.userVerifyPhoneOwner(data)
}

const startVideoKyc = async (data: UserVideoKYCStartInput) => {
  return await api.v1.userStartVideoKyc(data)
}

const uploadVideoKycDocument = async (formData: FormData) => {
  return await api.v1.userUploadVideoKycDocument({
    body: formData,
    type: ContentType.FormData,
  } as RequestParams)
}

const addVideoKycDocument = async (data: UserAddVideoDocumentInput) => {
  return await api.v1.userAddVideoKycDocument(data)
}

const verifyPersonalInfo = async (data: UserQuickKYCVerifyInput) => {
  return await api.v1.userVerifyPersonalInfo(data)
}

export default {
  quick,
  startVideoKyc,
  uploadVideoKycDocument,
  addVideoKycDocument,
  verifyPersonalInfo,
}
